module.exports = __webpack_public_path__ + "img/logo4.f1cc442a.png";